import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postVendors({ body }) {
  return BaseService.post(REST.VENDORS, body);
}

function putVendors({ body, id }) {
  return BaseService.put(REST.VENDORS_ID(id), body);
}

function getVendors(params) {
  return BaseService.get(REST.VENDORS, {
    params: paramsFilter({ params }),
  });
}

function deleteVendors({ id }) {
  return BaseService.delete(REST.VENDORS_ID(id));
}

export default {
  postVendors,
  putVendors,
  getVendors,
  deleteVendors,
};
